export enum ComplianceRegion {
  EU = 'EU',
  USA = 'USA',
  NONE = 'NONE',
  UK = 'UK',
  IS = 'IS',
  FI = 'FI'
}
